import { render, staticRenderFns } from "./TabelaFrota2.vue?vue&type=template&id=612ad047&"
import script from "./TabelaFrota2.vue?vue&type=script&lang=js&"
export * from "./TabelaFrota2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports